import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AccountEffects, accountReducer } from './store';

@NgModule({
  imports: [EffectsModule.forFeature([AccountEffects]), StoreModule.forFeature(`account`, accountReducer)]
})
export class AccountStateModule {}
